// extracted by mini-css-extract-plugin
module.exports = {"category":"category_category__1HFUb"};